import { MouseEvent, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Popover } from "@mui/material";
import { Help } from "@mui/icons-material";

import { formatItem } from "@framework/exchange";
import { IAchievementItemReport, IAchievementRule } from "@framework/types";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Button, Table, Typography } from "@dzambalaorg/ui-kit";

import { StyledPopoverWrapper } from "./styled";

export interface IAchievementInfoProps {
  rule: IAchievementRule;
  count: IAchievementItemReport;
}

export const AchievementInfoPopover = (props: IAchievementInfoProps) => {
  const { rule, count } = props;

  // const levelsRedeemed = achievementRule.levels.filter(lvl => lvl.redemptions!.length > 0);
  // const levelReached = achievementRule.levels.filter(lvl => lvl.amount <= count.count);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "achievement-info" : undefined;

  return (
    <StyledPopoverWrapper>
      <Button intent="icon" aria-describedby={id} onClick={handleClick}>
        <Help />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Table aria-label="rule parameters">
          <Table.Body>
            <Table.Row key={1}>
              <Table.Cell>
                <FormattedMessage id={`pages.achievements.info.description`} />
              </Table.Cell>
              <Table.Cell>
                <RichTextDisplay data={rule.description} />
              </Table.Cell>
            </Table.Row>
            <Table.Row key={2}>
              <Table.Cell>
                <FormattedMessage id={`pages.achievements.info.contract`} />
              </Table.Cell>
              <Table.Cell>
                <Typography>{rule.contract ? rule.contract.title : "any"}</Typography>
              </Table.Cell>
            </Table.Row>
            <Table.Row key={3}>
              <Table.Cell>
                <FormattedMessage id={`pages.achievements.info.event`} />
              </Table.Cell>
              <Table.Cell>
                <Typography>{rule.eventType ? rule.eventType : "any"}</Typography>
              </Table.Cell>
            </Table.Row>
            <Table.Row key={4}>
              <Table.Cell>
                <FormattedMessage id={`pages.achievements.info.items`} />
              </Table.Cell>
              <Table.Cell>
                <Typography>{formatItem(rule.item)}</Typography>
              </Table.Cell>
            </Table.Row>
            {rule.levels.reverse().map(level => (
              <Table.Row key={level.achievementLevel}>
                <Table.Cell>
                  <FormattedMessage
                    id={`pages.achievements.info.level`}
                    values={{
                      level: level.achievementLevel.toString(),
                      achieved: count && level.amount <= count.count ? "achieved" : "",
                      redeemed: level.redemptions!.length ? "redeemed" : "",
                    }}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Typography>{`${level.title}, get: ${formatItem(level.reward)}`}</Typography>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Popover>
    </StyledPopoverWrapper>
  );
};
